import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A55A] disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#C5A55A] text-[#1A1A1A] hover:bg-[#B09045] shadow-sm',
    outline: 'border-2 border-[#C5A55A] text-[#1A1A1A] hover:bg-[#FFF8F0]',
    ghost: 'hover:bg-[#FFF8F0] text-[#1A1A1A]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-640">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-641" />}
      {children}
    </button>;
}